import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { Observable, zip } from 'rxjs';
import { map } from 'rxjs/operators';

import { ConfigurarRelatorioCaixaApiService } from './services/configurar-relatorio-caixa-api.service';
import { RelatorioFinanceiroApiService } from '../relatorio-financeiro/services/relatorio-financeiro-api.service';
import { ConfigurarRelatorioCaixaResolverData } from './models/configurar-relatorio-caixa-resolver-data';

@Injectable()
export class ConfigurarRelatorioCaixaResolver implements Resolve<ConfigurarRelatorioCaixaResolverData> {

  constructor(
    private configurarRelatorioCaixaApiService: ConfigurarRelatorioCaixaApiService,
    private relatorioFinanceiroApiService: RelatorioFinanceiroApiService,
  ) { }

  resolve(): Observable<ConfigurarRelatorioCaixaResolverData> {
    return zip(
      this.configurarRelatorioCaixaApiService.listar(),
      this.relatorioFinanceiroApiService.getTiposLancamento(),
    ).pipe(
      map(([relatorios, tiposLancamento]) => ({ relatorios, tiposLancamento }))
    );
  }
}
